import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const ProjectsNavUI = ({ loan, page }) => (
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Projects' to={`/su/loans/${loan.loanId}/projects`} active={page === 'projects'} />
      <TabLinkUI label='Vehicle Types' to={`/su/loans/${loan.loanId}/vehicleTypes`} active={page === 'vehicleTypes'} />
    </div>
    <div className='g_m_top_50' />
  </div>
);

export default ProjectsNavUI;
